<template>
    <div>
        <div v-if="items !== null">
            <div v-if="items.length > 0">
                <slot name="before">
                    <div class="btn-group">
                        <button
                            v-if="!noPaginate"
                            class="btn btn-secondary btn-sm dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            Afficher par {{ params.paginate }}
                        </button>

                        <div class="dropdown-menu text-right">
                            <div
                                v-for="paginate of paginates"
                                :key="paginate"
                                class="dropdown-item cursor-pointer"
                                @click="$emit('paginate', paginate)"
                            >
                                {{ paginate }}
                            </div>
                        </div>
                    </div>

                    <button
                        v-if="!noExport"
                        class="btn btn-secondary btn-sm ml-2"
                        @click="$emit('export', $event)"
                    >
                        <i class="fas fa-download mr-2" /> Exporter
                    </button>

                    <slot name="extra-buttons" />

                    <div class="h4 float-right text-secondary font-weight-bold pb-1">
                        {{ meta.total }} {{ name | plural(meta.total) }}
                    </div>
                </slot>

                <div class="w-100 mb-3">
                    <table class="table table-sm table-bordered table-striped table-hover position-relative mb-0">
                        <BaseTableHeader
                            :head="head"
                            :order="params.order"
                            :direction="params.direction"
                            :no-orders="noOrders"
                            @orderBy="$emit('orderBy', $event)"
                        />

                        <tbody class="position-relative">
                            <slot />
                            <BaseTableLoader :loading="loading" />
                        </tbody>
                    </table>
                </div>

                <BasePaginate
                    v-if="meta"
                    :current-page="meta.current_page"
                    :last-page="meta.last_page"
                    @change-page="$emit('change-page', $event)"
                />
            </div>

            <div v-else>
                <slot name="no-results">
                    <div class="text-center h3 mt-5 pt-5">
                        Aucun {{ name }} trouvé...
                    </div>
                </slot>
            </div>
        </div>
        <BaseLoader v-else />
    </div>
</template>

<script>
    import BaseTableHeader from "./BaseTableHeader"
    import BaseLoader from "./BaseLoader"
    import BasePaginate from "./BasePaginate"
    import BaseTableLoader from "./BaseTableLoader"
    export default {
        name: "BaseTable",
        components: {BaseTableLoader, BasePaginate, BaseLoader, BaseTableHeader},

        props: {
            head: {type: Object, default: null},
            params: {type: Object, default: null},
            items: {type: Array, default: null},
            meta: {type: Object, default: null},
            name: {type: String, default: null},
            loading: Boolean,
            noOrders: Boolean,
            noExport: Boolean,
            noPaginate: Boolean
        },

        data: function () {
            return {
                paginates: [15, 25, 50]
            }
        }
    }
</script>
